<div class="termsConditionsContainer">
  <h1>{{ "terms_and_conditions.title" | translate }}</h1>
  @for (item of "terms_and_conditions.elements" | translate; track item) {
    <h2>{{ item.title }}</h2>
    <p>
      {{ item.text }}
    </p>
  }
</div>
